import { useUserFeatures } from "../../contexts/UserFeaturesContext";

const useIsMarketingBannersEnabled = (): boolean => {
  const features = useUserFeatures();
  return !!features.olb_enable_marketing_banners;
};

export default useIsMarketingBannersEnabled;
